// ===== Mueblika · Página de categoría =====
(function () {
  // Ordenar: recarga la página con el parámetro sort_by
  const sortSelect = document.querySelector('[data-mbk-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // Añadir rápido al carrito desde la tarjeta (usa la variante por
  // defecto del producto; si el producto tiene varias variantes,
  // el cliente puede afinar tamaño/color entrando a la ficha)
  document.querySelectorAll('[data-mbk-quick-add]').forEach((button) => {
    button.addEventListener('click', () => {
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Añadiendo...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            throw new Error(data.description || 'No se pudo añadir el producto');
          }
          button.textContent = 'Añadido ✓';
          document.dispatchEvent(new CustomEvent('mbk:cart:item-added', { detail: data }));

          // Igual que en la ficha de producto: refresca el número real
          // del carrito y el header, sin recargar la página — si no,
          // la burbuja se queda sin actualizar en la primera compra.
          fetch('/cart.js', { cache: 'no-store' })
            .then((res) => res.json())
            .then((cart) => {
              const selectors = [
                '.cart-bubble__text-count',
                '[ref="cartBubbleCount"]',
                '[data-cart-count]',
                '.cart-count',
                '.cart-count-bubble',
                '.cart-icon-bubble',
                '[data-cart-item-count]',
              ];
              selectors.forEach((sel) => {
                document.querySelectorAll(sel).forEach((el) => {
                  el.textContent = cart.item_count;
                  el.removeAttribute('hidden');
                  el.classList.remove('hidden');
                });
              });
            })
            .catch(() => {});

          const headerSection =
            document.querySelector('[id*="header_section"]') ||
            document.querySelector('[id^="shopify-section-header"]');
          const cartDrawerSection =
            document.querySelector('[id*="cart-drawer"]') ||
            document.querySelector('[id*="cart_drawer"]') ||
            document.querySelector('[id*="CartDrawer"]');

          const sectionsToRefresh = [];
          if (headerSection) sectionsToRefresh.push(headerSection);
          if (cartDrawerSection) sectionsToRefresh.push(cartDrawerSection);

          if (sectionsToRefresh.length) {
            const sectionIds = sectionsToRefresh
              .map((el) => el.id.replace('shopify-section-', ''))
              .join(',');

            fetch('/?sections=' + sectionIds + '&mbk_cache_bust=' + Date.now(), { cache: 'no-store' })
              .then((res) => res.json())
              .then((sections) => {
                sectionsToRefresh.forEach((el) => {
                  const sectionId = el.id.replace('shopify-section-', '');
                  const html = sections[sectionId];
                  if (!html) return;
                  const parser = new DOMParser();
                  const newDoc = parser.parseFromString(html, 'text/html');
                  const newEl = newDoc.getElementById(el.id);
                  if (newEl) el.outerHTML = newEl.outerHTML;
                });
              })
              .catch(() => {});
          }

          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 1800);
        })
        .catch(() => {
          button.textContent = 'Error, reintenta';
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 1800);
        });
    });
  });
})();